export default __webpack_public_path__ + "static/media/video19.5f2473b0.webp";